import React from 'react';
import clsx from 'clsx';
import { Container } from 'semantic-ui-react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { findError, validationClasses } from '@/utils/errors';
import fields from '@/constants/fields';
import ValidationSpan from '@/components/errors/ValidationSpan';
import MarkdownEditor from '@/components/text-editors/MarkdownEditor';
import HoverMarkdownContainer from '@/components/wrappers/HoverMarkdownContainer';
import { editCohort, updateCohortProperties } from '../actions';
import { canEditCohort } from '../helper';

const CohortDescription = ({
  code,
  category,
  description,
  isEditing,
  canEdit,
  updateDescription,
  validationErrors,
  showEdit,
  mobilePadding,
}) => {
  if (!canEdit && !description) {
    return null;
  }

  const validationError = findError(validationErrors, 'cohort', [fields.DESCRIPTION]);

  return (
    <Container fluid className={clsx('aridhia-cohort-description', mobilePadding && 'mt-10')}>
      <ValidationSpan validationError={validationError} />
      {!isEditing && (
        <HoverMarkdownContainer
          canEdit={canEdit}
          showEdit={() => showEdit(category, code)}
          value={description}
          editText="click.to.edit.description"
          position="top"
          toolTip="bottom right"
          editCopyMods="field-container"
          as="h2"
          className="aridhia-cohort-list-container aridhia-h3"
        />
      )}
      {canEdit && isEditing && (
        <MarkdownEditor
          id="cohort_description"
          value={description}
          onChange={(value) => updateDescription(category, code, value)}
          maxEditorHeight={100}
          minPreviewHeight={90}
          className={validationClasses(validationError, 'aridhia-h3 aridhia-is-edit-mode')}
        />
      )}
    </Container>
  );
};

const mapStateToProps = ({
  auth: { role },
  cohorts: { cohorts },
}, { category, code }) => {
  const item = findResult(cohorts, category, code);
  const isEditing = item ? item.isEditing : false;
  const validationErrors = item ? item.saveErrors : null;
  const queryAccess = item ? item.access.query_access : false;

  return (
    {
      isEditing,
      description: item ? item.description : '',
      canEdit: item ? canEditCohort(item, role) && queryAccess : false,
      validationErrors,
    }
  );
};

const mapDispatchToProps = {
  updateDescription: (category, code, value) => updateCohortProperties(category, code, { description: value }),
  showEdit: editCohort,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortDescription);
